package com.nonopn.skydome.common.app.navigation

import androidx.compose.material.icons.Icons
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue

import com.nonopn.icons.Logout
import com.nonopn.skydome.common.app.home.AppModel
import com.nonopn.skydome.common.app.home.LocalApp
import com.nonopn.skydome.common.app.pages.densities.DensitiesScreen
import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.menu_strikeradar_densities
import com.nonopn.skywatcher.design.appbar.AppBarState
import com.nonopn.skywatcher.design.widgets.MenuItem

import eu.codlab.navigation.NavigateTo
import eu.codlab.navigation.NavigateToStack
import eu.codlab.navigation.NavigateWithNavOptions
import eu.codlab.navigation.Route
import eu.codlab.navigation.RouteParameterTo
import eu.codlab.navigation.RouterNoParameters

import kotlinx.serialization.Serializable

@Serializable
object RouteLightningDensitiesNormal : RouteParameterTo

object RouterLightningDensitiesNormal :
    RouterNoParameters<RouteLightningDensitiesNormal>(RouteLightningDensitiesNormal::class) {
    override fun routeFrom(parameters: RouteLightningDensitiesNormal) = "/densities/normal"

    @Composable
    override fun Show(parameters: RouteLightningDensitiesNormal) {
        RouteLightningDensitiesNormalImpl().scene()
    }

    override fun navigateTo() = NavigateTo(
        route = RouteLightningDensitiesNormal,
        stack = NavigateToStack(
            popBackStack = true,
            options = NavigateWithNavOptions(
                launchSingleTop = true
            )
        )
    )

    override fun isCurrentRoute(routeParameterTo: RouteParameterTo?) =
        null != routeParameterTo && routeParameterTo is RouteLightningDensitiesNormal

    override fun isMatching(route: String) = route == "/densities/normal"

    override fun navigateFrom(path: String) = RouteLightningDensitiesNormal
}

class RouteLightningDensitiesNormalImpl : Route<RouteLightningDensitiesNormal>(
    route = "/densities/normal",
    params = RouteLightningDensitiesNormal,
) {
    @Composable
    override fun scene() {
        val appModel: AppModel = LocalApp.current
        val state by appModel.states.collectAsState()

        LaunchedEffect(Unit) {
            onEntryIsActive(appModel, emptyList())
        }

        DensitiesScreen(
            currentInterface = state.apiProvider!!.apiNormal,
            onNavigateKeraunic = { uuid, name, lat, lon ->
                appModel.show(RouterKeraunicReport.navigateTo(RouteKeraunicReport(uuid, name, lat, lon)))
            },
            onNavigateCertNsg = { uuid, name, lat, lon ->
                appModel.show(RouterCertNsg.navigateTo(RouteCertNsg(uuid, name, lat, lon)))
            },
            onNavigateLightningCertificates = {
                appModel.show(RouterLightningCertificatesNormal.navigateTo())
            }
        )
    }

    private fun onEntryIsActive(
        appModel: AppModel,
        defaultActions: List<MenuItem>,
    ) {
        appModel.setAppBarState(
            AppBarState.Localized(
                title = Res.string.menu_strikeradar_densities,
                defaultActions + MenuItem.MenuItemSimple(
                    imageVector = Icons.Rounded.Logout,
                    onClick = {
                        appModel.logout()
                    }
                )
            )
        )
    }
}
